import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  readonly pdfName: string;
  readonly riskIncreaseReasons: readonly string[];
}

export default function FlagNotesInfo({ pdfName, riskIncreaseReasons }: Props) {
  const pdfNameWithoutExtension = pdfName.substring(0, pdfName.length - 4);
  const formattedRiskIncreaseReasons = riskIncreaseReasons.map((reason) => (
    <span key={reason}>
      {reason}
      <br />
    </span>
  ));

  return (
    <Box sx={{ width: '100%' }}>
      <div>
        <Typography>
          <span>
            {`${pdfNameWithoutExtension} - was flagged for the following reasons:`}
            <br />
          </span>
        </Typography>
        <br />
        <Typography sx={{ color: '#EE5A49' }}>{formattedRiskIncreaseReasons}</Typography>
      </div>
    </Box>
  );
}
